import { createFileRoute, redirect } from '@tanstack/react-router';
import { PermissionSetSummaryPage } from '@/app/(client)/company-settings/-components/permissionSets/PermissionSetSummaryPage';
import { ensurePermissions } from '@/hooks/usePermissions';
import { useSessionStore } from '@/store/sessionStore';

export const Route = createFileRoute(
  '/(client)/company-settings/(pages)/permission-sets/$setKey/',
)({
  // Reading one set is `permission-access:read`, the same as the list.
  beforeLoad: async () => {
    const perms = await ensurePermissions();
    if (!perms['permission-access'].canRead) {
      throw redirect({ to: '/company-settings/users' });
    }
  },
  component: PermissionSetSummaryRoute,
});

function PermissionSetSummaryRoute() {
  const { setKey } = Route.useParams();
  const companyId = useSessionStore(s => s.user?.companyId);
  if (!companyId) return null;
  return <PermissionSetSummaryPage companyId={companyId} setKey={setKey} />;
}
